import { Application } from '@hotwired/stimulus'

import ChargeablePaymentTermController from './chargeable_payment_term_controller'
import ClickToCopyController from './click_to_copy_controller'
import CountryStateSelectController from './country_state_select_controller'
import CorporateFieldsController from './corporate_fields_controller'
import CreditCardFormController from './credit_card_form_controller'
import ExperienceSelectorController from './experience_selector_controller'
import GclidFieldController from './gclid_field_controller'
import InfoRequestGtmController from './info_request_gtm_controller'
import IntlTelInputController from './intl_tel_input_controller'
import PackageSelectController from './package_select_controller'
import PaymentTermSelectorController from './payment_term_selector_controller'
import PaymentTermsController from './payment_terms_controller'
import PayNowFormController from './pay_now_form_controller'
import RequiredFieldController from './required_field_controller'
import PopoverController from './popover_controller'
import TabsController from './tabs_controller'
import ToggleContentController from './toggle_content_controller'
import TravelHotelDestinationController from './travel_hotel_destination_controller'
import TurnstileController from './turnstile_controller'

const application = Application.start()

application.register('chargeable-payment-term', ChargeablePaymentTermController)
application.register('click-to-copy', ClickToCopyController)
application.register('country-state-select', CountryStateSelectController)
application.register('corporate-fields', CorporateFieldsController)
application.register('credit-card-form', CreditCardFormController)
application.register('experience-selector', ExperienceSelectorController)
application.register('gclid-field', GclidFieldController)
application.register('info-request-gtm', InfoRequestGtmController)
application.register('intl-tel-input', IntlTelInputController)
application.register('package-select', PackageSelectController)
application.register('payment-term-selector', PaymentTermSelectorController)
application.register('payment-terms', PaymentTermsController)
application.register('pay-now-form', PayNowFormController)
application.register('required-field', RequiredFieldController)
application.register('popover', PopoverController)
application.register('tabs', TabsController)
application.register('toggle-content', ToggleContentController)
application.register('travel-hotel-destination', TravelHotelDestinationController)
application.register('turnstile', TurnstileController)
